import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-communication-address-card-icon',
  templateUrl: './communication-address-card.component.html'
})
export class CommunicationAddressCardComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
